import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import cx from 'classnames';
import { Button } from '@vimily/bonjoro-ui-components';
import { palette } from '~/utils/colours';
import Text from '~/App/Components/Text';
import { Tab } from './ShareTab';

const Icon = styled.span<{ isActive: boolean }>`
  ${(props) => {
    if (props.isActive) {
      return `
        svg path{
          fill: ${palette.tealishFour};
        }
      `;
    }
  }}
`;

export type TabItemProps = {
  title: string;
  tab: Tab;
  icon: ReactNode;
  activeTab: Tab;
  onRequestTab: (tab: Tab) => void;
};

export default function TabItem({
  title,
  tab,
  icon,
  onRequestTab,
  activeTab,
}: TabItemProps) {
  return (
    <span className='text-center'>
      <Button
        className={cx('outline-none hover:border-green-700', {
          'border-green-700 bg-turquoise-100': activeTab === tab,
        })}
        variant='secondary'
        onClick={() => onRequestTab(tab)}
      >
        <Icon
          className={cx('text-2xl text-neutral-400', {
            'fill-current text-green-700': activeTab === tab,
          })}
          isActive={activeTab === tab}
        >
          {icon}
        </Icon>
      </Button>
      <Text.BodyCopy as='div' className='mt-3'>
        {title}
      </Text.BodyCopy>
    </span>
  );
}
